import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getContentList } from '../../features/notice/noticeSlice';
import { formatDate } from '../../utils/formatDate';
import { Pagination } from "react-bootstrap";
import { setEndpoint, clearEndpoint } from '../../features/notice/noticeSlice';
import "../../css/pagination.css";
import wizLogo from '../../img/symbol_dark.png';  
import { FadeLoader } from 'react-spinners';

const NoticeGrid = ({ categoryId, dataStyle, vsData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [pageIndex, setPageIndex] = useState(1);

  const periodDate = useSelector((state) => state.setting.periodDate);
  const contentList = useSelector((state) => state.notice.contentList);
  const categories = useSelector((state) => state.notice.categories || []);
  const settings = useSelector((state) => state.setting.settings);
  const totalCount = useSelector((state) => state.notice.totalCount); 
  const endpoint = useSelector((state) => state.notice.endpoint || `/content?ca=${categoryId}&vs=${vsData}&pi=${pageIndex}&ds=${dataStyle}`) ;
  const GRID_VIEW_COUNT = settings.gridViewCount;

  const [loading, setLoading] = useState(true);
  
  
//console.log(contentList)

  const goDetail = (noticeId) => {
    dispatch(setEndpoint(endpoint));
    navigate(`/notice/${noticeId}`);
  };

  const shouldShowLoadMoreButton = (contentList?.length < totalCount) || false;
  const totalPages = totalCount ? Math.ceil(totalCount / GRID_VIEW_COUNT) : 1;

  const moreData = () => {
    dispatch(clearEndpoint());
    setPageIndex((prevIndex) => prevIndex + 1);
  };

  const handlePageChange = (selectedPage) => {
    setPageIndex(selectedPage); 
  };

  //#region useEffect
  // 게시글 리스트 로딩
  useEffect(() => {
    if(vsData==="grid"){
      const fetchData = async () => {
        setLoading(true);  
      try {
        if (pageIndex > 1) {
          dispatch(getContentList(endpoint, true));
        } else {
          dispatch(getContentList(endpoint));
        }
      } catch (error) {
        console.error("데이터 요청 실패:", error);
      } finally {
        setLoading(false); 
      }
    };
    fetchData();
  }
  }, [dispatch, endpoint, pageIndex, categoryId, vsData]);

  
  useEffect(() => {
    setPageIndex(1);
  }, [categoryId]);

  const [loadedFlags, setLoadedFlags] = useState([]);

  //게시글 이미지 로딩
  useEffect(() => {
    const loadImagesSequentially = async () => {
      const flags = [];
  
      for (let i = 0; i < contentList.length; i++) {
        const item = contentList[i];
        const imageURL = item.thumbImgURI || wizLogo;
  
        await new Promise((resolve) => {
          const img = new Image();
          img.src = imageURL;
          img.onload = resolve;
          img.onerror = resolve;
        });
  
        flags.push(true); 
        setLoadedFlags([...flags]); 
      }
    };
  
    loadImagesSequentially();
  }, [contentList]);
  
  
  //#endregion

  return (
    <div>
      {loading ? (
        <FadeLoader
          color="#9a9a9a"
          height={10}
          width={4}
          style={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        />
      ) : contentList && contentList.length > 0 ? (
      <ul className="news_list bo-grid">
        {contentList.map((item, index) => {
          const category = categories.find(cat => cat.id === item.category_id);
          const categoryName = category ? category.name : '카테고리';

          const noticePeriodDate = new Date().getTime() - periodDate * 24 * 60 * 60 * 1000;
          const isLatest = new Date(item.created_at).getTime() >= noticePeriodDate;
          const preview = item.PREVIEW_YN;

          return (
            <li key={index} onClick={() => goDetail(item.id)}>
              <a href={item.link || ''}>
                <div className="bo-grid-img">
                  {loadedFlags[index] ? (
                    <img
                      src={item.thumbImgURI || wizLogo}
                      alt={item.title || '공지사항 이미지'}
                      className={!item.thumbImgURI ? 'default-logo' : 'thumbnail'}
                      onError={(e) => {
                        e.target.src = wizLogo;
                        e.target.className = 'default-logo';
                      }}
                    />
                  ) : (
                    <div className="spinner-box">
                      <FadeLoader color="#ffffff" />
                    </div>
                  )}
                </div>
                <div className="bo-grid-text">
                  <div className="status-container">
                    {item.category_id && <mark>{categoryName}</mark>}
                    {preview === 'Y' && <p>임시저장</p>}
                  </div>
                  <strong>
                    {isLatest && <span className="icon_new lg" title="새로운 알림"></span>}
                    {item.title}
                  </strong>
                  <span>{formatDate(item.created_at)}</span>
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    ) : (
      <div className="empty_table">게시물이 없습니다.</div> 
    )}

      {dataStyle === "pagging" ? (
        totalPages > 1 && (
          <div className="pagination-container">
            <Pagination>
              <Pagination.Prev
                onClick={() => pageIndex > 1 && setPageIndex(pageIndex - 1)}
                disabled={pageIndex === 1}
              />
              {[...Array(totalPages)].map((_, index) => {
                const page = index + 1;
                return (
                  <Pagination.Item
                    key={page}
                    active={page === pageIndex}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              })}
              <Pagination.Next
                onClick={() => pageIndex < totalPages && setPageIndex(pageIndex + 1)}
                disabled={pageIndex === totalPages}
              />
            </Pagination>
          </div>
        )
      ) : (
        shouldShowLoadMoreButton && (
          <div className="scroll">
            <span className='btn-more' onClick={moreData}>더보기</span>
          </div>
        )
      )}
    </div>
  );
};

export default NoticeGrid;
